export default __webpack_public_path__ + "static/media/new-about-bg.91fcb39c.jpg";